import "../styles/Benefits.css"
const Benefits = () => {

  return (
    <section class="benefits-section">
      <div>
        <h2 class="section-title">Benefits of Haronics Cold Pressed Oils</h2>
        <div class="row">

          <div class="col-lg-3 col-md-6">
            <div class="benefit-card">
              <div class="icon-container">
                <i class="fas fa-heart"></i>
              </div>
              <h4 class="benefit-title">Heart Health</h4>
              <p class="benefit-desc">Our natural oils are rich in healthy fats that promote cardiovascular
                health and reduce cholesterol levels.
              </p>
            </div>
          </div>
          {/* <!-- Benefit 2 --> */}
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card">
              <div class="icon-container">
                <i class="fas fa-brain"></i>
              </div>
              <h4 class="benefit-title">Brain Function</h4>
              <p class="benefit-desc">Essential fatty acids in our oils support cognitive function and may
                help prevent neurodegenerative diseases.
              </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="benefit-card">
              <div class="icon-container">
                <i class="fas fa-shield-alt"></i>
              </div>
              <h4 class="benefit-title">Immune Support</h4>
              <p class="benefit-desc">Antioxidants and nutrients in our oils help strengthen your immune
                system and fight inflammation.
              </p>
            </div>
          </div>
          {/* <!-- Benefit 4 --> */}
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card">
              <div class="icon-container">
                <i class="fas fa-spa"></i>
              </div>
              <h4 class="benefit-title">Skin Health</h4>
              <p class="benefit-desc">Natural oils nourish your skin, improve elasticity, and help maintain a
                youthful, radiant appearance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Benefits
